import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

export const useQuery = (): { [key: string]: string | undefined } => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const result: { [key: string]: string } = {};

    searchParams.forEach((value, key) => {
      result[key] = value;
    });

    return result;
  }, [searchParams]);
};
